<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Anti Rangging Committee</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">College Development Committee</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table--4">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th>Affiliation / Organization</th>
                <th>Designation Within CDC</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>Mr. Sunil Raisoni</td>
                <td>Chairman, G.H.Raisoni Educational & Medical Foundation</td>
                <td>Chairman</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Mr. Sudhakar Jagdale</td>
                <td>Secretary, G.H.Raisoni Educational & Medical Foundation</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Mr. Ashwin Pande</td>
                <td>Director HR, RGI</td>
                <td>Member Management</td>
              </tr>
              <tr>
                <td>4.</td>
                <td>Dr. Aarti Deshpande</td>
                <td>Director, Management Institute, RGI</td>
                <td>Member Management</td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Dr. Suresh Dharane</td>
                <td>Principal GHRCACS Pune</td>
                <td>Member Secretary</td>
              </tr>
              <tr>
                <td>6.</td>
                <td>Prof. Prafulla Jadhav</td>
                <td>Teacher, GHRCACS Pune</td>
                <td>Member - Coordinator</td>
              </tr>
              <tr>
                <td>7.</td>
                <td>Dr. Mohit Raut</td>
                <td>Teacher, GHRCACS Pune</td>
                <td>Member Teacher</td>
              </tr>
              <tr>
                <td>8.</td>
                <td>Prof. Sarika Kulthe</td>
                <td>Women Teacher, GHRCACS Pune</td>
                <td>Member Teacher</td>
              </tr>
              <tr>
                <td>9.</td>
                <td>Prof. Snehal V. Sinalkar</td>
                <td>Women Teacher, GHRCACS Pune</td>
                <td>Member Teacher</td>
              </tr>
              <tr>
                <td>10.</td>
                <td>Prof. Paramela Jogadande</td>
                <td>Women Teacher, GHRCACS Pune</td>
                <td>Member Teacher</td>
              </tr>
              <tr>
                <td>11.</td>
                <td>Shri. Rambhau Dabhade</td>
                <td>Ex. Zillha Parishad Member</td>
                <td>Local Member</td>
              </tr>
              <tr>
                <td>12.</td>
                <td>Shri. Natraj Satav</td>
                <td>Social Service</td>
                <td>Local Member</td>
              </tr>
              <tr>
                <td>13.</td>
                <td>Shri. Sandip Satav</td>
                <td>Social Service</td>
                <td>Local Member</td>
              </tr>
              <tr>
                <td>14.</td>
                <td>Mr. Shivam Tumbade</td>
                <td>Alumni Representative</td>
                <td>Member Alumni</td>
              </tr>
              <tr>
                <td>15.</td>
                <td>Ms. Kiran Thakur</td>
                <td>President of Student Council</td>
                <td>Member Student</td>
              </tr>
            </tbody>
          </table>
          <!-- <table class="table table-bordered table-striped table--4">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Name Of the Member</th>
                  <th>Designation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1.</td>
                  <td>Mr. Sunil Raisoni</td>
                  <td>Chairman of Management</td>
                </tr>
                <tr>
                  <td>2.</td>
                  <td>Mr. Ajit Tatiya</td>
                  <td>Secretary</td>
                </tr>
                <tr>
                  <td>3.</td>
                  <td>Dr. Rajendra V. Suryawanshi</td>
                  <td>Principal GHRCACS Pune</td>
                </tr>
                <tr>
                  <td>4.</td>
                  <td>Dr. Sachin Chavan</td>
                  <td>Coordinator</td>
                </tr>
                <tr>
                  <td>5.</td>
                  <td>Dr. Mohit Raut</td>
                  <td>Teacher</td>
                </tr>
                <tr>
                  <td>6.</td>
                  <td>Prof. Sarika Kulthe</td>
                  <td>Women Teacher</td>
                </tr>
                <tr>
                  <td>7.</td>
                  <td>Prof. Prafulla Jadhav</td>
                  <td>Teacher</td>
                </tr>
                <tr>
                  <td>8.</td>
                  <td>Dr. Jayashri Lohar</td>
                  <td>Teacher</td>
                </tr>
                <tr>
                  <td>9.</td>
                  <td>Shri. Rambhau Dabhade</td>
                  <td>Local Member</td>
                </tr>
                <tr>
                  <td>10.</td>
                  <td>Shri. Santosh Sonar</td>
                  <td>Local Member</td>
                </tr>
                <tr>
                  <td>11.</td>
                  <td>Mr. Prakash B. Satav</td>
                  <td>Local Member</td>
                </tr>
                <tr>
                  <td>12.</td>
                  <td>Ms. Kaveri Argade</td>
                  <td>Student Nominee</td>
                </tr>
                <tr>
                  <td>13.</td>
                  <td>Mr. Himanshu Nag </td>
                  <td>President</td>
                </tr>
              </tbody>
            </table> -->
        </div>
      </div>
    </div>
  </div>
</section>
